module.exports = __webpack_public_path__ + "img/icon-projections.b423ce8d.svg";